// extracted by mini-css-extract-plugin
export default {"mainWrapper":"PrivacyPolicy_mainWrapper__hY1xX","mainContainer":"PrivacyPolicy_mainContainer__cE+kU","mainContent":"PrivacyPolicy_mainContent__x5jQh"};